import axiosApi from "../axiosInstance";
import { getReduxCompany, getStoredUser, getStoredCompany } from "../../helper/sessionHelper";
const user = getStoredUser();

const getassetList = async (assedId) => {
  try {
    const response = await axiosApi.get(`/Asset/getasset/${assedId}`);
    return response?.data;
  } catch (error) {
    console.log("Error getassetList===>:", error);
    return error?.response?.data;
  }
};

const getassetDetailsById = async (requestId, userId) => {
  try {
    const response = await axiosApi.get(
      `/Asset/GetAssetRequestById/` + requestId + "/" + userId
    );
    return response?.data;
  } catch (error) {
    console.log("Error getassetDetailsById===>:", error);
    return error?.response?.data;
  }
};

const getassetDrop = async () => {
  try {
    const response = await axiosApi.get(`/Asset/getAssetDrop`);
    return response?.data;
  } catch (error) {
    console.log("Error getassetDrop===>:", error);
    return error?.response?.data;
  }
};
const addAsset = async (body) => {
  try {
    //body.companyId = user?.companyId || 0;
    body.companyId = getStoredCompany()?.companyId || 0;
    const response = await axiosApi.post(`Asset/createasset`, body);
    return response?.data;
  } catch (error) {
    console.log("Error addAsset ===>", error);
    return error?.response?.data;
  }
};
const getassetType = async () => {
  try {
    const response = await axiosApi.get(`/Asset/getAssetType`);
    return response?.data;
  } catch (error) {
    console.log("Error getassetType===>:", error);
    return error?.response?.data;
  }
};

const getassetserial = async (year, month) => {
  try {
    const response = await axiosApi.get(
      `/Asset/getAssetSrNo/` + year + "/" + month
    );
    return response?.data;
  } catch (error) {
    console.log("Error getassetserial===>:", error);
    return error?.response?.data;
  }
};

const getAssetDocumentCategoryDropdown = async () => {
  try {
    const response = await axiosApi.get(
      `/Asset/getAssetDocumentCategoryDropdown`
    );
    return response?.data;
  } catch (error) {
    console.log("Error getAssetDocumentCategoryDropdown===>:", error);
    return error?.response?.data;
  }
};

const getAssetDocumentTypeDropdown = async (documentCategoryId) => {
  try {
    const response = await axiosApi.get(
      `/Asset/getAssetDocumentTypeDropdown/${documentCategoryId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error getDocumentTypeDropdown===>:", error);
    return error?.response?.data;
  }
};

const addAssetRequest = async (body) => {
  try {
    //body.companyId = user?.companyId || 0;
    body.companyId = getStoredCompany()?.companyId || 0;
    const response = await axiosApi.post(`Asset/createAssetRequest`, body);
    return response?.data;
  } catch (error) {
    console.log("Error addAssetRequest ===>", error);
    return error?.response?.data;
  }
};

const addAssetRequestList = async (body) => {
  try {
    //body.companyId = user?.companyId || 0;
    body.companyId = getStoredCompany()?.companyId || 0;
    const response = await axiosApi.post(`Asset/GetAssetRequest`, body);
    return response?.data;
  } catch (error) {
    console.log("Error addAssetRequestList ===>", error);
    return error?.response?.data;
  }
};

const addAssetRequestSubList = async (subId, catId) => {
  try {
    const response = await axiosApi.get(
      `Asset/GetAssetRequestSub` + "/" + subId + "/" + catId
    );
    return response?.data;
  } catch (error) {
    console.log("Error addAssetRequestSubList ===>", error);
    return error?.response?.data;
  }
};

const getAssetAttachmentList = async (assedId) => {
  try {
    const response = await axiosApi.get(
      `Asset/getAssetAttachmentAlert/${assedId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error getAssetAttachmentList ===>", error);
    return error?.response?.data;
  }
};

const saveAssetAttachment = async (body) => {
  try {
    //body.companyId = user?.companyId || 0;
    body.companyId = getStoredCompany()?.companyId || 0;
    const response = await axiosApi.post(`Asset/saveAssetAttachment`, body);
    return response?.data;
  } catch (error) {
    console.log("Error saveAssetAttachment ===>", error);
    return error?.response?.data;
  }
};

const deleteAssetAttachment = async (assetAttachmentId, assetId) => {
  try {
    const response = await axiosApi.post(
      `Asset/deleteAssetAttachment/${assetAttachmentId}/${assetId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error deleteAssetAttachment ===>", error);
    return error?.response?.data;
  }
};

const updateAssetRequestStatus = async (body) => {
  try {
    //body.companyId = user?.companyId || 0;
    body.companyId = getStoredCompany()?.companyId || 0;
    const response = await axiosApi.post(
      `Asset/update_asset_request_status`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error updateAssetRequestStatus ===>", error);
    return error?.response?.data;
  }
};

const assignUserForAsset = async (body) => {
  try {
    //body.companyId = user?.companyId || 0;
    body.companyId = getStoredCompany()?.companyId || 0;
    const response = await axiosApi.post(`Asset/assignUser`, body);
    return response?.data;
  } catch (error) {
    console.log("Error assignUserForAsset ===>", error);
    return error?.response?.data;
  }
};

const assignCustodianUserForAsset = async (body) => {
  try {
    //body.companyId = user?.companyId || 0;
    body.companyId = getStoredCompany()?.companyId || 0;
    const response = await axiosApi.post(`Asset/assignCustodianUser`, body);
    return response?.data;
  } catch (error) {
    console.log("Error assignCustodianUserForAsset ===>", error);
    return error?.response?.data;
  }
};

const scrappedAsset = async (body) => {
  try {
    //body.companyId = user?.companyId || 0;
    body.companyId = getStoredCompany()?.companyId || 0;
    const response = await axiosApi.post(`Asset/scrappedAsset`, body);
    return response?.data;
  } catch (error) {
    console.log("Error scrappedAsset ===>", error);
    return error?.response?.data;
  }
};

const getAssetRequestStatusDropdown = async () => {
  try {
    const response = await axiosApi.get(
      `AssetStatus/getAllAssetRequestStatusDropdown`
    );
    return response?.data;
  } catch (error) {
    console.error("Error fetching project data:", error);
    return error?.response?.data;
  }
};

const assetMovementRequestList = async (body) => {
  try {
    //body.companyId = user?.companyId || 0;
    body.companyId = getStoredCompany()?.companyId || 0;
    const response = await axiosApi.post(`Asset/GetAssetMovement`, body);
    return response?.data;
  } catch (error) {
    console.log("Error assetMovementRequestList ===>", error);
    return error?.response?.data;
  }
};

const assetMovementRequestListById = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(`Asset/GetAssetMovementById`, body);
    return response?.data;
  } catch (error) {
    console.log("Error assetMovementRequestListById ===>", error);
    return error?.response?.data;
  }
};

const updateAssetMovementRequestDetails = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(
      `Asset/UpdateAssetMovementRequestDetails`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error updateAssetMovementRequestDetails ===>", error);
    return error?.response?.data;
  }
};

const updateAssetMovementRequestSub = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(
      `Asset/UpdateAssetMovementRequestSub`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error updateAssetMovementRequestSub ===>", error);
    return error?.response?.data;
  }
};

const getAssetMovementDetailsById = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(`/Asset/GetAssetMovementById/`, body);
    return response?.data;
  } catch (error) {
    console.log("Error getAssetMovementDetailsById===>:", error);
    return error?.response?.data;
  }
};

const getAssetStatusDropdown = async (assetStatusType) => {
  try {
    const response = await axiosApi.get(
      `AssetStatus/getAllAssetStatusDropdown/${assetStatusType}`
    );
    return response?.data;
  } catch (error) {
    console.error("Error fetching project data:", error);
    return error?.response?.data;
  }
};

const updateAssetMovementRequestStatus = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(
      `Asset/UpdateAssetMovementRequestStatus`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error updateAssetRequestStatus ===>", error);
    return error?.response?.data;
  }
};

const moveAssetRequestToMovement = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(
      `Asset/MoveAssetRequestToMovement`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error moveAssetRequestToMovement ===>", error);
    return error?.response?.data;
  }
};

const moveAssetRequestToPurchase = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(
      `Asset/MoveAssetRequestToPurchase`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error moveAssetRequestToPurchase ===>", error);
    return error?.response?.data;
  }
};
const getAssetRequestWorkflowCategory = async (formId) => {
  try {
    const response = await axiosApi.get(`/Asset/getWorkflowCategory/${formId}`);
    return response?.data;
  } catch (error) {
    console.log("Error getAssetRequestWorkflowCategory===>:", error);
    return error?.response?.data;
  }
};

const getAssetSerialNoDropdown = async (categoryId, subCategoryId) => {
  try {
    const response = await axiosApi.get(
      `/Asset/getAssetSerialDropdown/${categoryId}/${subCategoryId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error getAssetSerialNoDropdown===>:", error);
    return error?.response?.data;
  }
};

const getAssetScrap = async (assetScrapId, userId) => {
  try {
    const response = await axiosApi.get(
      `/Asset/getAssetScrap/${assetScrapId}/${userId}/${
        getStoredCompany()?.companyId || 0
      }`
    );
    return response?.data;
  } catch (error) {
    console.log("Error getAssetScrap===>:", error);
    return error?.response?.data;
  }
};

const getAssetScrapSub = async (assetScrapId) => {
  try {
    const response = await axiosApi.get(
      `/Asset/getAssetScrapSub/${assetScrapId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error getAssetScrapSub===>:", error);
    return error?.response?.data;
  }
};

const saveAssetScrapRequest = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(`Asset/saveAssetScrapRequest`, body);
    return response?.data;
  } catch (error) {
    console.log("Error saveAssetScrapRequest ===>", error);
    return error?.response?.data;
  }
};

const deleteAssetScrapSub = async (assetScrapSubId) => {
  try {
    const response = await axiosApi.post(
      `Asset/deleteAssetScrapSub/${assetScrapSubId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error deleteAssetScrapSub ===>", error);
    return error?.response?.data;
  }
};

const myTaskList = async (body) => {
  try {    
    //body.companyId = getStoredCompany()?.companyId || 0;;
    body.companyId = getStoredCompany()?.companyId || 0;
    const response = await axiosApi.post(`Asset/MyTask`, body);
    return response?.data;
  } catch (error) {
    console.log("Error myTaskList ===>", error);
    return error?.response?.data;
  }
};

const sendAssetRequestBackToDraft = async (assetRequestId, userId, remark) => {
  try {
    const response = await axiosApi.post(
      `Asset/SendAssetRequestBackToDraft/${assetRequestId}/${userId}/${remark}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error sendAssetRequestBackToDraft ===>", error);
    return error?.response?.data;
  }
};

const sendAssetRequestBackToReCall = async (assetRequestId, userId, remark) => {
  try {
    const response = await axiosApi.post(
      `Asset/SendAssetRequestBackToReCall/${assetRequestId}/${userId}/${remark}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error sendAssetRequestBackToReCall ===>", error);
    return error?.response?.data;
  }
};

const getAssetScrapHistory = async (assetScrapId) => {
  try {
    const response = await axiosApi.get(
      `/Asset/getAssetScrapHistory/${assetScrapId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error getAssetScrapHistory===>:", error);
    return error?.response?.data;
  }
};

const approveAssetScrap = async (assetScrapId, userId) => {
  try {
    const response = await axiosApi.post(
      `/Asset/approveAssetScrapRequest/${assetScrapId}/${userId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error approveAssetScrap===>:", error);
    return error?.response?.data;
  }
};

const sendBackToNormalAssetScrap = async (assetScrapId, userId) => {
  try {
    const response = await axiosApi.get(
      `/Asset/SendAssetScrapRequestBackToDraft/${assetScrapId}/${userId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error sendBackToNormalAssetScrap===>:", error);
    return error?.response?.data;
  }
};

const recallAssetScrap = async (assetScrapId, userId) => {
  try {
    const response = await axiosApi.get(
      `/Asset/SendAssetScrapRequestBackToReCall/${assetScrapId}/${userId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error recallAssetScrap===>:", error);
    return error?.response?.data;
  }
};

const getAssetPurchaseRequestList = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(`Asset/GetAssetPurchaseRequest`, body);
    return response?.data;
  } catch (error) {
    console.log("Error getAssetPurchaseRequestList ===>", error);
    return error?.response?.data;
  }
};

const addAssetPurchaseRequestSubList = async (subId, catId) => {
  try {
    const response = await axiosApi.get(
      `Asset/GetAssetPurchaseById` + "/" + subId + "/" + catId
    );
    return response?.data;
  } catch (error) {
    console.log("Error addAssetPurchaseRequestSubList ===>", error);
    return error?.response?.data;
  }
};

const getWorkflowGroup = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(`Asset/getWorkflowGroup`, body);
    return response?.data;
  } catch (error) {
    console.log("Error getWorkflowGroup ===>", error);
    return error?.response?.data;
  }
};

const updateAssetStatus = async (assetId, statusId, userId) => {
  try {
    const response = await axiosApi.post(
      `/Asset/updateAssetStatus/${assetId}/${statusId}/${userId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error updateAssetStatus===>:", error);
    return error?.response?.data;
  }
};

const getStatusDropdown = async (statusType) => {
  try {
    const response = await axiosApi.get(
      `AssetStatus/getStatusList/${statusType}`
    );
    return response?.data;
  } catch (error) {
    console.error("Error getStatusDropdown:", error);
    return error?.response?.data;
  }
};

const sendAssetMovementRequestBackToDraft = async (
  assetMovementRequestId,
  userId,
  remark
) => {
  try {
    const response = await axiosApi.get(
      `Asset/SendAssetMovementRequestBackToDraft/${assetMovementRequestId}/${userId}/${remark}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error SendAssetMovementRequestBackToDraft ===>", error);
    return error?.response?.data;
  }
};

const sendAssetMovementRequestBackToReCall = async (
  assetMovementRequestId,
  userId,
  remark
) => {
  try {
    const response = await axiosApi.get(
      `Asset/SendAssetMovementRequestBackToReCall/${assetMovementRequestId}/${userId}/${remark}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error sendAssetMovementRequestBackToReCall ===>", error);
    return error?.response?.data;
  }
};

const updateAssetPR = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(`/Asset/UpdateAssetPR`, body);
    return response?.data;
  } catch (error) {
    console.log("Error updateAssetPR===>:", error);
    return error?.response?.data;
  }
};

const getAssetDispatch = async (assetDispatchId, userId) => {
  try {
    const response = await axiosApi.get(
      `/Asset/getAssetDispatch/${assetDispatchId}/${userId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error getAssetDispatch===>:", error);
    return error?.response?.data;
  }
};

const updateAssetDispatchStatus = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(
      `/Asset/updateAssetDispatchStatus`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error updateAssetDispatchStatus===>:", error);
    return error?.response?.data;
  }
};

const getAssetAcknowledge = async (assetAcknowledgeId, userId) => {
  try {
    const response = await axiosApi.get(
      `/Asset/getAssetAcknowledge/${assetAcknowledgeId}/${
        getStoredCompany()?.companyId || 0
      }/${userId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error getAssetAcknowledge===>:", error);
    return error?.response?.data;
  }
};

const moveAssetRequestToQuotation = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(
      `Asset/MoveAssetRequestToQuotation`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error moveAssetRequestToQuotation ===>", error);
    return error?.response?.data;
  }
};

const assetQuotationList = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(`Asset/GetAssetQuotation`, body);
    return response?.data;
  } catch (error) {
    console.log("Error assetQuotationList ===>", error);
    return error?.response?.data;
  }
};

const assetQuotationById = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(`Asset/GetAssetQuotationById`, body);
    return response?.data;
  } catch (error) {
    console.log("Error assetQuotationById ===>", error);
    return error?.response?.data;
  }
};

const saveAssetQuotationVendor = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(
      `Asset/saveAssetQuotationVendor`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error saveAssetQuotationVendor ===>", error);
    return error?.response?.data;
  }
};

const getAssetQuotationVendors = async (quotationRequestId, id) => {
  try {
    const response = await axiosApi.post(
      `Asset/GetAssetQuotationVendors/${quotationRequestId}/${id}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error getAssetQuotationVendors ===>", error);
    return error?.response?.data;
  }
};

const deleteAssetQuotationVendors = async (id) => {
  try {
    const response = await axiosApi.post(
      `Asset/DeleteAssetQuotationVendors/${id}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error deleteAssetQuotationVendors ===>", error);
    return error?.response?.data;
  }
};

const updateAssetPurchaseQuotationDetails = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(
      `Asset/UpdateAssetPurchaseQuotationDetails`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error updateAssetPurchaseQuotationDetails ===>", error);
    return error?.response?.data;
  }
};

const updateAssetQuotationPurchaseRequestStatus = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(
      `Asset/UpdateAssetQuotationPurchaseRequestStatus`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error updateAssetQuotationPurchaseRequestStatus ===>", error);
    return error?.response?.data;
  }
};

const sendAssetQuotationPurchaseRequestBackToDraft = async (
  assetQuotationPurchaseRequestId,
  userId,
  statusId,
  remark
) => {
  try {
    const response = await axiosApi.get(
      `Asset/SendAssetQuotationPurchaseRequestBackToDraft/${assetQuotationPurchaseRequestId}/${userId}/${statusId}/${remark}`
    );
    return response?.data;
  } catch (error) {
    console.log(
      "Error sendAssetQuotationPurchaseRequestBackToDraft ===>",
      error
    );
    return error?.response?.data;
  }
};

const sendAssetQuotationPurchaseRequestBackToReCall = async (
  assetQuotationPurchaseRequestId,
  userId,
  remark
) => {
  try {
    const response = await axiosApi.get(
      `Asset/SendAssetQuotationPurchaseRequestBackToReCall/${assetQuotationPurchaseRequestId}/${userId}/${remark}`
    );
    return response?.data;
  } catch (error) {
    console.log(
      "Error sendAssetQuotationPurchaseRequestBackToReCall ===>",
      error
    );
    return error?.response?.data;
  }
};

const acknowledgeAsset = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(`/Asset/acknowledgeAsset`, body);
    return response?.data;
  } catch (error) {
    console.log("Error acknowledgeAsset===>:", error);
    return error?.response?.data;
  }
};

const importSAPDetails = async (purchaseRequestId, movementTypeId) => {
  try {
    const response = await axiosApi.post(
      `Asset/importSAPDetails/${purchaseRequestId}/${movementTypeId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error importSAPDetails ===>", error);
    return error?.response?.data;
  }
};

const getAssetQuotationVendorAttachments = async (
  quotationRequestId,
  vendorId
) => {
  try {
    const response = await axiosApi.post(
      `Asset/GetAssetQuotationVendorAttachment/${quotationRequestId}/${vendorId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error getAssetQuotationVendors ===>", error);
    return error?.response?.data;
  }
};

const getWorkOrderDropdown = async (ownerTypeId, vendorId, projectId) => {
  try {
    const response = await axiosApi.get(
      `Asset/getWorkOrderDropdown/${ownerTypeId}/${vendorId}/${projectId}`
    );
    return response?.data;
  } catch (error) {
    console.error("getWorkOrderDropdown:", error);
    return error?.response?.data;
  }
};

const saveAssetMaterialMovementRequest = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(
      `/Asset/saveAssetMaterialMovementRequest`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error saveAssetMaterialMovementRequest===>:", error);
    return error?.response?.data;
  }
};

const getAssetMaterialMovementSub = async (materialMrId) => {
  try {
    const response = await axiosApi.get(
      `Asset/getAssetMaterialMovementSub/${materialMrId}`
    );
    return response?.data;
  } catch (error) {
    console.error("getAssetMaterialMovementSub:", error);
    return error?.response?.data;
  }
};

const deleteAssetMaterialMovementSub = async (materialMrSubId) => {
  try {
    const response = await axiosApi.post(
      `Asset/deleteAssetMaterialMovementSub/${materialMrSubId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error deleteAssetMaterialMovementSub ===>", error);
    return error?.response?.data;
  }
};

const getAssetMaterialMovementList = async (materialMrId, userId) => {
  try {
    const response = await axiosApi.get(
      `Asset/getAssetMaterialMovement/${materialMrId}/${userId}`
    );
    return response?.data;
  } catch (error) {
    console.error("getAssetMaterialMovementList:", error);
    return error?.response?.data;
  }
};

const getAssetMaterialMovementHistoryList = async (materialMrId) => {
  try {
    const response = await axiosApi.get(
      `Asset/getAssetMaterialMovementHistory/${materialMrId}`
    );
    return response?.data;
  } catch (error) {
    console.error("getAssetMaterialMovementHistoryList:", error);
    return error?.response?.data;
  }
};

const approveAssetMaterialMovementRequest = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(
      `/Asset/approveAssetMaterialMovementRequest`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error approveAssetMaterialMovementRequest===>:", error);
    return error?.response?.data;
  }
};

const sendBackToDraftAssetMaterialMovementRequest = async (
  materialMrId,
  userId,
  formId,
  remark
) => {
  try {
    const response = await axiosApi.post(
      `/Asset/sendBackToDraftAssetMaterialMovementRequest/${materialMrId}/${userId}/${formId}/${remark}`
    );
    return response?.data;
  } catch (error) {
    console.log(
      "Error sendBackToDraftAssetMaterialMovementRequest===>:",
      error
    );
    return error?.response?.data;
  }
};

const recallAssetMaterialMovementRequest = async (
  materialMrId,
  userId,
  formId,
  remark
) => {
  try {
    const response = await axiosApi.post(
      `/Asset/recallAssetMaterialMovementRequest/${materialMrId}/${userId}/${formId}/${remark}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error recallAssetMaterialMovementRequest===>:", error);
    return error?.response?.data;
  }
};

const getMaterialMovementOrder = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(
      `Asset/GetMaterialMovementOrder`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error getMaterialMovementOrder ===>", error);
    return error?.response?.data;
  }
};

const getMaterialMovementOrderById = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(
      `/Asset/GetMaterialMovementById/`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error getMaterialMovementOrderById===>:", error);
    return error?.response?.data;
  }
};

const updateMaterialMovementRequestStatus = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(
      `Asset/UpdateMaterialMovementRequestStatus`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error updateMaterialMovementRequestStatus ===>", error);
    return error?.response?.data;
  }
};

const sendMaterialMovementOrderBackToDraft = async (
  materialMovementRequestId,
  userId,
  remark
) => {
  try {
    const response = await axiosApi.get(
      `Asset/SendMaterialMovementOrderBackToDraft/${materialMovementRequestId}/${userId}/${remark}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error sendMaterialMovementOrderBackToDraft ===>", error);
    return error?.response?.data;
  }
};

const sendMaterialMovementOrderBackToReCall = async (
  materialMovementRequestId,
  userId,
  remark
) => {
  try {
    const response = await axiosApi.get(
      `Asset/SendMaterialMovementOrderBackToReCall/${materialMovementRequestId}/${userId}/${remark}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error sendMaterialMovementOrderBackToReCall ===>", error);
    return error?.response?.data;
  }
};

const updateMaterialMovementRequestDetails = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(
      `Asset/UpdateMaterialMovementRequestDetails`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error updateMaterialMovementRequestDetails ===>", error);
    return error?.response?.data;
  }
};

const updateMaterialMovementRequestSub = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(
      `Asset/UpdateMaterialMovementRequestSub`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error updateMaterialMovementRequestSub ===>", error);
    return error?.response?.data;
  }
};

const getQuotationVendorLineItems = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(
      `Asset/GetQuotationVendorLineItems`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error getQuotationVendorLineItems ===>", error);
    return error?.response?.data;
  }
};

const getQuotationAllVendorLineItems = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(
      `Asset/GetQuotationAllVendorLineItems`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error getQuotationAllVendorLineItems ===>", error);
    return error?.response?.data;
  }
};

const getPendingAssetRequest = async () => {
  try {
    const response = await axiosApi.get(
      `Asset/getPendingAssetRequest/${getStoredCompany()?.companyId || 0}`
    );
    return response?.data;
  } catch (error) {
    console.error("getPendingAssetRequest:", error);
    return error?.response?.data;
  }
};

const deleteQuotationVendorLineItem = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(
      `Asset/DeleteQuotationVendorLineItem`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error deleteQuotationVendorLineItem ===>", error);
    return error?.response?.data;
  }
};

const deletePurchaseHireMovementRequest = async (
  referenceId,
  requestId,
  requestTypeId,
  userId,
  formId
) => {
  try {
    const response = await axiosApi.post(
      `Asset/DeleteRequest/${referenceId}/${requestId}/${requestTypeId}/${userId}/${formId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error deletePurchaseHireMovementRequest ===>", error);
    return error?.response?.data;
  }
};

const deleteQuotationVendorItem = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(
      `Asset/DeleteQuotationVendorItem`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error deleteQuotationVendorItem ===>", error);
    return error?.response?.data;
  }
};

const moveAssetRequestToAsetPurchase = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(
      `Asset/MoveAssetRequestToAsetPurchase`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error moveAssetRequestToAsetPurchase ===>", error);
    return error?.response?.data;
  }
};

const deleteAssetRequest = async (requestId) => {
  try {
    const response = await axiosApi.post(
      `Asset/DeleteAssetRequest/${requestId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error deleteAssetRequest ===>", error);
    return error?.response?.data;
  }
};

const addDispatchDetails = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(`Asset/AddDispatchDetails`, body);
    return response?.data;
  } catch (error) {
    console.log("Error addDispatchDetails ===>", error);
    return error?.response?.data;
  }
};

const getDispatchTripDetails = async (dispatchId) => {
  try {
    const response = await axiosApi.get(
      `Asset/getDispatchTripDetails/${dispatchId}`
    );
    return response?.data;
  } catch (error) {
    console.error("getDispatchTripDetails:", error);
    return error?.response?.data;
  }
};

const getApprovedAssetRequest = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(`Asset/GetApprovedAssetRequest`, body);
    return response?.data;
  } catch (error) {
    console.log("Error addAssetRequestList ===>", error);
    return error?.response?.data;
  }
};

const updateActionAssetRequestSub = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(
      `Asset/UpdateActionAssetRequestSub`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error updateActionAssetRequestSub ===>", error);
    return error?.response?.data;
  }
};

const updateActionAssetRequestSubStatus = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;

    const response = await axiosApi.post(
      `Asset/UpdateActionAssetRequestSubStatus`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error updateActionAssetRequestSub ===>", error);
    return error?.response?.data;
  }
};

const getAssetActionRequestById = async (requestId, userId) => {
  try {
    const response = await axiosApi.get(
      `/Asset/GetAssetActionRequestById/` + requestId + "/" + userId
    );
    return response?.data;
  } catch (error) {
    console.log("Error getAssetActionRequestById===>:", error);
    return error?.response?.data;
  }
};

const sendAssetActionRequestBackToDraft = async (
  assetRequestId,
  userId,
  remark
) => {
  try {
    const response = await axiosApi.post(
      `Asset/SendAssetActionRequestBackToDraft/${assetRequestId}/${userId}/${remark}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error sendAssetActionRequestBackToDraft ===>", error);
    return error?.response?.data;
  }
};

const sendAssetActionRequestBackToReCall = async (
  assetRequestId,
  userId,
  remark
) => {
  try {
    const response = await axiosApi.post(
      `Asset/SendAssetActionRequestBackToReCall/${assetRequestId}/${userId}/${remark}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error sendAssetActionRequestBackToReCall ===>", error);
    return error?.response?.data;
  }
};

const getMaterialMovementRequestById = async (materialMrId) => {
  try {
    const response = await axiosApi.get(
      `/Asset/getMaterialMovementRequestById/${materialMrId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error getMaterialMovementRequestById===>:", error);
    return error?.response?.data;
  }
};

const reSubmitDispatchDetails = async (body) => {
  try {
    const response = await axiosApi.post(
      `Asset/ResubmitDispatchTripDetails`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error reSubmitDispatchDetails ===>", error);
    return error?.response?.data;
  }
};

const getAssetAvailableLocations = async (categoryId, subCategoryId) => {
  try {
    const response = await axiosApi.get(
      `Asset/getAssetAvailableSite/${categoryId}/${subCategoryId}/${
        getStoredCompany()?.companyId || 0
      }`
    );
    return response?.data;
  } catch (error) {
    console.log("Error getAssetAvailableLocations ===>", error);
    return error?.response?.data;
  }
};

export const assetService = {
  getassetList,
  getassetDetailsById,
  addAsset,
  getassetDrop,
  getAssetDocumentCategoryDropdown,
  getAssetDocumentTypeDropdown,
  addAsset,
  getassetDrop,
  getassetType,
  getassetserial,
  addAssetRequest,
  addAssetRequestList,
  addAssetRequestSubList,
  getAssetAttachmentList,
  saveAssetAttachment,
  deleteAssetAttachment,
  assignUserForAsset,
  assignCustodianUserForAsset,
  scrappedAsset,
  updateAssetRequestStatus,
  getAssetRequestStatusDropdown,
  assetMovementRequestList,
  assetMovementRequestListById,
  updateAssetMovementRequestDetails,
  updateAssetMovementRequestSub,
  getAssetMovementDetailsById,
  getAssetStatusDropdown,
  updateAssetMovementRequestStatus,
  moveAssetRequestToMovement,
  moveAssetRequestToPurchase,
  getAssetRequestWorkflowCategory,
  getAssetSerialNoDropdown,
  getAssetScrap,
  getAssetScrapSub,
  saveAssetScrapRequest,
  deleteAssetScrapSub,
  myTaskList,
  sendAssetRequestBackToDraft,
  sendAssetRequestBackToReCall,
  getAssetScrapHistory,
  approveAssetScrap,
  sendBackToNormalAssetScrap,
  recallAssetScrap,
  getAssetPurchaseRequestList,
  addAssetPurchaseRequestSubList,
  getWorkflowGroup,
  updateAssetStatus,
  getStatusDropdown,
  sendAssetMovementRequestBackToDraft,
  sendAssetMovementRequestBackToReCall,
  updateAssetPR,
  getAssetDispatch,
  updateAssetDispatchStatus,
  getAssetAcknowledge,
  updateAssetPR,
  moveAssetRequestToQuotation,
  assetQuotationList,
  assetQuotationById,
  saveAssetQuotationVendor,
  getAssetQuotationVendors,
  deleteAssetQuotationVendors,
  updateAssetPurchaseQuotationDetails,
  updateAssetQuotationPurchaseRequestStatus,
  sendAssetQuotationPurchaseRequestBackToDraft,
  sendAssetQuotationPurchaseRequestBackToReCall,
  acknowledgeAsset,
  importSAPDetails,
  getAssetQuotationVendorAttachments,
  getWorkOrderDropdown,
  saveAssetMaterialMovementRequest,
  getAssetMaterialMovementSub,
  deleteAssetMaterialMovementSub,
  getAssetMaterialMovementList,
  getAssetMaterialMovementHistoryList,
  approveAssetMaterialMovementRequest,
  sendBackToDraftAssetMaterialMovementRequest,
  recallAssetMaterialMovementRequest,
  getMaterialMovementOrder,
  getMaterialMovementOrderById,
  updateMaterialMovementRequestStatus,
  sendMaterialMovementOrderBackToDraft,
  sendMaterialMovementOrderBackToReCall,
  updateMaterialMovementRequestDetails,
  updateMaterialMovementRequestSub,
  getQuotationVendorLineItems,
  getQuotationAllVendorLineItems,
  getPendingAssetRequest,
  deleteQuotationVendorLineItem,
  deletePurchaseHireMovementRequest,
  deleteQuotationVendorItem,
  moveAssetRequestToAsetPurchase,
  deleteAssetRequest,
  getApprovedAssetRequest,
  updateActionAssetRequestSub,
  updateActionAssetRequestSubStatus,
  getAssetActionRequestById,
  sendAssetActionRequestBackToDraft,
  sendAssetActionRequestBackToReCall,
  addDispatchDetails,
  getDispatchTripDetails,
  getMaterialMovementRequestById,
  reSubmitDispatchDetails,
  getAssetAvailableLocations,
};
